import React, {useState, useEffect, useContext} from "react";
import {AppButton, ResetButton} from "../../styles/Butttons";
import Modal from "../../containers/Modal";
import {Input} from "../../styles/Forms";
import {Grid, Col} from "../../styles/Grid";
import styled from "styled-components";
import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";
import {AuthContext} from "../../context/AuthProvider";

let data = {
   name: "Santiago Cabrera",
   area: "marketing",
   email: "stiagocabrera@gmail.com",
   password: "8sda8s",
};

export default function MyProfileModal({isOpen, close, theme}) {
   const {userData} = useContext(AuthContext);
   const [showSuccess, setSuccess] = useState(false);
   const [edit, setEdit] = useState(false);

   useEffect(() => {
      setSuccess(false);
      setEdit(false);
   }, [isOpen]);

   const SaveUser = (e) => {
      e.preventDefault();
      const formda = e.target;
      let newUser = {
         ...data,
         last_name: formda.name.value.split(" ")[1],
         name: formda.name.value,
         first_name: "sadsa",
         area: formda.area.value,
         email: formda.email.value,
         password: formda.password.value,
      };
      console.log(newUser);
      setSuccess(true);
   };

   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         confirm={false}
         theme={theme}
         showSuccess={showSuccess}
         title="Añadir administrador"
      >
         <DivModal>
            {edit ? (
               <FormEdit save={SaveUser} />
            ) : (
               <Grid>
                  <Col large="9">
                     <p className="textModal">Nombre:</p>
                     <Input
                        className="readGhost principal"
                        defaultValue={userData.userName + " " + userData.userLastName}
                        readOnly={true}
                        placeholder="Nombre"
                        name="name"
                     />
                  </Col>
                  {/* <Col large="3">
                     <ResetButton
                        onClick={() => {
                           setEdit(true);
                        }}
                     >
                        <EditIcon width="2em" height="2em" />
                     </ResetButton>
                  </Col> */}
                  <Col large="5">
                     <p className="textModal">Ciudad:</p>
                     <Input className="readGhost" defaultValue={userData.city} readOnly={true} name="city" />
                  </Col>
                  <Col large="2" />
                  <Col large="5">
                     <p className="textModal">Email:</p>
                     <Input className="readGhost" defaultValue={userData.email} readOnly={true} placeholder="E-Mail" name="email" />
                  </Col>
                  {/* <Col large="5">
                     <p className="textModal">Nombre:</p>
                     <Input className="readGhost" defaultValue={userData.phone} readOnly={true} name="phone" />
                  </Col> */}
                  <Col large="2" />
                  <Col large="5"></Col>
                  <Col large="5"></Col>
               </Grid>
            )}
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
`;

const FormEdit = ({save}) => (
   <form onSubmit={save}>
      <Grid>
         <Col large="9">
            <Input defaultValue={data.name} placeholder="Nombre" name="name" />
         </Col>
         {/* <Col large="4" /> */}
         <Col large="5">
            <Input defaultValue={data.area} placeholder="Area" name="area" />
         </Col>
         <Col large="2" />
         <Col large="5">
            <Input defaultValue={data.email} placeholder="E-Mail" name="email" />
         </Col>
         <Col large="5">
            <Input defaultValue={data.password} placeholder="Contraseña" name="password" />
         </Col>
         <Col large="2" />
         <Col large="5">
            <Input placeholder="Confirmar contraseña" name="confirmPassword" />
         </Col>
         <Col large="5"></Col>
      </Grid>
      <Grid>
         <Col large="3" offsetL="9" className="buttonModal">
            <AppButton>Guardar</AppButton>
         </Col>
      </Grid>
   </form>
);
